export default {
    vidfleetClips_id: "Id",
    vidfleetClips_companyName: "Company Name",
    vidfleetClips_clipId: "Clip Id",
    vidfleetClips_unitId: "Unit Id",
    vidfleetClips_unitLabel: "Unit Label",
    vidfleetClips_esn: "ESN",
    vidfleetClips_deviceModelName: "Device Model Name",
    vidfleetClips_errorMsg: "Error Message",
    vidfleetClips_startDate: "Start Date",
    vidfleetClips_endDate: "End Date",
    vidfleetClips_status: "Status",
    vidfleetClips_createdOnDb: "Created On",
    vidfleetClips_no_data_to_display: "No data to display",
}